export default __webpack_public_path__ + "locales/ko-KR/Payments.json?hash=7cd5b366fe11910a878d1fb10a78ed45";